import { ReactNode } from 'react'
import { Category, CategoryProps } from './category'
import styles from './integrations.module.css'

interface WrapperProps extends CategoryProps {
  children: ReactNode
}
export function Wrapper({
  categories,
  selectedCategory,
  children
}: WrapperProps): JSX.Element {
  return (
    <section
      id="integration-list"
      className={styles.directory}
      aria-label="Browse integrations"
    >
      <div className={`${styles.container} ${styles.layout}`}>
        <Category categories={categories} selectedCategory={selectedCategory} />
        <div className={styles.results}>{children}</div>
      </div>
    </section>
  )
}
